<template>
  <nav01 title="群公告"></nav01>
  <div class="paltfrom-page">
    <ul>
      <li
        v-for="(item, index) in state.teamNotice"
        @click="goNoticedetails(item.id)"
      >
        <div class="publishTitle">
          <span>{{ item.post_title }}</span>
        </div>
        <p class="publishText">
          {{ item.post_excerpt }}
        </p>
        <p class="publishTime">{{ item.post_date }}</p>
        <i v-if="!state.readNotice.includes(item.id)"></i>
      </li>
    </ul>

    <div class="empty" v-if="state.teamNotice.length == 0">
      <img
        src="../../assets//chat/icon_chatNotnotice.png"
        alt=""
        class="noNotice"
      />
    </div>
    <van-overlay :show="state.showLoading" duration="0">
      <van-loading
        size="28"
        color="#12cec7"
        v-if="state.showLoading"
        vertical="true"
      >
        加载中...
      </van-loading>
    </van-overlay>
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { reactive, onActivated, onDeactivated, onMounted } from "vue";
import { useStore } from "vuex";
import { groupNotice } from "@/api/chat";
export default {
  name: "PickDesc",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const state = reactive({
      nim: null,
      groupId: "",

      // 群公告
      teamNotice: [],

      // 新增群公告
      readNotice: [],
      showLoading: true,
    });
    // 返回
    const onClickLeft = () => {
      router.back();
    };

    onMounted(() => {
      state.groupId = route.query.groupId;

      // 获取群公告
      getNotice();

      // 获取已读公告
      getReadNotice();
    });

    onActivated(() => {
      state.showLoading = true;
      state.groupId = route.query.groupId;

      // 获取群公告
      getNotice();

      // 获取已读公告
      getReadNotice();
    });

    // const onBackButtonPressed = () => {
    //   history.pushState(null, null, location.href );  // 增加历史记录
    //   console.log("监听到了");
    // }

    onDeactivated(() => {
      state.groupId = "";
      state.teamNotice = [];
      state.readNotice = [];
    });

    // 获取群公告
    const getNotice = () => {
      groupNotice({
        groupid: state.groupId,
      }).then((res) => {
        // console.log('群公告返回的数据-----------------', res)
        // console.log('群公告返回的数据-----------------', res.data.data)
        if (res.data.code == 1) {
          state.teamNotice = res.data.data.lists;
          // if(state.teamNotice == null){
          //   state.teamNotice = res.data.data.lists
          // }
        }
        state.showLoading = false;
      });
    };
    // 获取已读公告
    const getReadNotice = () => {
      if (localStorage.getItem(state.groupId)) {
        state.readNotice = JSON.parse(localStorage.getItem(state.groupId));
      }
    };

    //公告详情
    const goNoticedetails = (id) => {
      // console.log("本群id--------------s", state.groupId);
      //查看本地是否有该群组的id
      if (!localStorage.getItem(state.groupId)) {
        localStorage.setItem(state.groupId, JSON.stringify([id]));
      } else {
        let arr = JSON.parse(localStorage.getItem(state.groupId));
        if (!arr.includes(id)) {
          arr.push(id);
          localStorage.setItem(state.groupId, JSON.stringify(arr));
        }
      }

      state.readNotice.push(id);
      router.push({
        path: "/publicNotice",
        query: {
          id: id,
        },
      });
    };

    return {
      state,
      onClickLeft,
      // getTeamInfo,
      goNoticedetails,
    };
  },
};
</script>

<style src="../../styles/van-sticky-nav.css"></style>
<style scoped="scoped">
.paltfrom-page {
  padding: 0 32px;
  padding-top: calc(112px + constant(safe-area-inset-top));
  padding-top: calc(112px + env(safe-area-inset-top));
  height: 100vh;
  background-color: #161b1f;
}

#iframename {
  /* height: -webkit-fill-available; */
  width: 100%;
  height: 2000px;
}

ul li {
  background-color: #283138;
  width: 686px;
  height: 228px;
  padding: 24px;
  border-radius: 24px;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
ul li i {
  width: 12px;
  height: 12px;
  background: #ff6666;
  border-radius: 50%;
  position: absolute;
  right: 30px;
  top: 30px;
}
.publishTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* margin-bottom: 20px; */
  color: #fff;
}

.publishTitle span:nth-of-type(2) {
  width: 12px;
  height: 12px;
  background-color: #ff6666;
  border-radius: 50%;
}

.publishText {
  /* height: 68px; */
  font-size: 24px;
  overflow: hidden;
  color: #999999;
  /* white-space: nowrap; */
  /* text-overflow: ellipsis; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.publishTime {
  /* margin-top: 24px; */
  font-size: 20px;
  color: #999999;
}

.empty {
  width: 100%;
  display: flex;
  justify-content: center;
}
.noNotice {
  width: 400px;
}
:deep(.van-overlay) {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #161B1F;
}
:deep(.van-loading) {
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.van-loading__text) {
  color: #12cec7;
}
</style>
